import { LOCATION_TYPES } from '@/pages/dashboard/mapping/model/constants';
import { Location } from '@/pages/dashboard/mapping/model/types';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface FilteredLocationProps {
  location: Location;
  total: number;
}

export function FilteredLocation({ location, total }: FilteredLocationProps) {
  const { Icon, color, label } = LOCATION_TYPES[location];

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex items-center gap-1 cursor-help">
          <Icon className={cn('h-4 w-4', color)} />
          <span>{total}</span>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p>
          {label}: {total}
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
